import { type RectReadOnly } from 'react-use-measure';

import { getCssVar, setCssVar } from './cssVar';

const measureToCssVars = (rect: RectReadOnly, namePrefix: string): void => {
  for (const field in rect) {
    setCssVar(`${namePrefix}-${field}`, `${rect[field]}px`);
  }
};

const parseMeasureFromCssVars = (namePrefix: string): RectReadOnly => {
  const result: RectReadOnly = {
    x: 0,
    y: 0,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0,
  };

  for (const field in result) {
    const cssValue = getCssVar(`${namePrefix}-${field}`);
    result[field] = parseFloat(cssValue) || 0;
  }

  return result;
};

export { measureToCssVars, parseMeasureFromCssVars };
